import { useAuth } from '@/app/AuthContext.jsx';
import { useCan } from './useCan';

/**
 * `true` when the active membership is an owner, or a member holding
 * `permission`. The API gives an owner every permission of the org's capability
 * and ignores the stored array, so a gate that mirrors an API permission has to
 * include the owner. `useCan` alone reads the stored array.
 */
export function useCanAsMember(permission) {
  const { isOwner } = useAuth();
  const canRead = useCan(permission);
  return Boolean(isOwner) || canRead;
}
